import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { PeriodValue, generatePeriodOptions } from '../periodOptions'

type PeriodSelectorProps = {
  initialPeriod: PeriodValue
  onApply: (period: PeriodValue) => void
}

const periodOptions = generatePeriodOptions({})

export const PeriodSelector = ({
  initialPeriod,
  onApply,
}: PeriodSelectorProps) => {
  const [selectedPeriod, setSelectedPeriod] =
    useState<PeriodValue>(initialPeriod)

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
        期間
      </Typography>
      <Stack direction="row" sx={{ gap: 2, alignItems: 'center', mb: 3 }}>
        <FormControl size="small" sx={{ minWidth: 200, width: '100%' }}>
          <Select
            value={selectedPeriod}
            onChange={e => setSelectedPeriod(e.target.value as PeriodValue)}
            displayEmpty
          >
            {periodOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onApply(selectedPeriod)}
        >
          適用
        </Button>
      </Stack>
    </Stack>
  )
}
